<template>
    <div>
        <div class="header">
            <header-tag
                :title="$PAGE_API.home.children.accountSafe.title"
            ></header-tag>
        </div>
        <div style="overflow:hidden">
            <safe-left style="float:left"></safe-left>
            <safe-right style="float:left"></safe-right>
        </div>
        <!-- <loading :show="true"></loading> -->
    </div>
</template>
<script>
// import loading from '_c/modals/loading'
import HeaderTag from "_c/tagTitle/headerTag";
import SafeLeft from "./safeLeft";
import SafeRight from "./safeRight";
import { getUserInfo } from "@/requests/user";
import { mapActions } from "vuex";
export default {
    name: "accountSafe",
    components: {
        HeaderTag,
        SafeLeft,
        SafeRight
        // loading
    },
    data() {
        return {
            form: {}
        };
    },
    mounted() {
        // this.getUser()
    },
    methods: {
        ...mapActions(["user/actionSetUserInfo"]),
        async getUser() {
            let res = await getUserInfo();
            this.form = res.data;
            if (res.code == 200) {
                this["user/actionSetUserInfo"](res.data);
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.header {
    padding-left: 30px;
    // padding-top: 20px;
    text-align: left;
    height: 70px;
    line-height: 70px;
    border-bottom: 1px solid #d9dee4;
}
safe-left {
    width: 500px;
}
</style>
